import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Student  {
    _originalTypeClassName = "ekylikeio.BO.Student";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Student.translate = translateService;
}
this.studentToOrder = [];
this.Id = null;
this.FullName = null;
this.AM = null;
this.DisplayName = null;
this.IsDeleted = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
FullName:any;
AM:any;
DisplayName:any;
IsDeleted:any;
Parent:any;
studentToOrder:any;
SchoolClass:any;
static setParent = ($this, value) => {
var oldValue = $this.Parent;
$this.Parent = value;
if (value != null) {
if (oldValue != null) {
Domain.Parent.removeparentToStudent(oldValue, $this);
}
Domain.Parent.addparentToStudent(value, $this);
}
}
static setstudentToOrder = ($this, items) => {
                if (items == null) items = [];
                if ($this.studentToOrder == null) $this.studentToOrder = [];

                const copyItems = Common.cloneObject(items);

                while ($this.studentToOrder.length > 0) {
                    Domain.Student.removestudentToOrder($this, $this.studentToOrder[0]);
                }

                Domain.Student.addManystudentToOrder($this, copyItems);
            }
static addManystudentToOrder = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Student.addstudentToOrder($this, items[i]);
                }
            }
static addstudentToOrder = ($this, item) => {
                if ($this.studentToOrder == null) $this.studentToOrder = [];
                if (item == null || $this.studentToOrder.indexOf(item) > -1) return;
                $this.studentToOrder.push(item);
}
static addRangestudentToOrder = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Student.addstudentToOrder($this, item));
            }
static removestudentToOrder = ($this, item) => {
                if ($this == null || $this.studentToOrder == null || $this.studentToOrder.indexOf(item) === -1) return;
                var _index = $this.studentToOrder.indexOf(item);
                $this.studentToOrder.splice(_index, 1);
}
static clearstudentToOrder = ($this) => { $this.studentToOrder = null; }
static setSchoolClass = ($this, value) => {
var oldValue = $this.SchoolClass;
$this.SchoolClass = value;
if (value != null) {
}
}

static GetDisplayName($this: any): any{return $this?.FullName + (($this?.SchoolClass == null ? "" : " - " + $this?.SchoolClass?.FullName));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}